var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard9({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 334,
    viewBox: "0 0 388 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 334,
    rx: 24,
    fill: "#F4FFFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149 196.423L174.382 171.559C174.46 171.482 174.586 171.483 174.663 171.56L188.967 185.864C189.045 185.942 189.171 185.942 189.25 185.865L239.634 136M239.634 136H224.007M239.634 136V150.585",
    stroke: "#546E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.543 197.465L177.649 182.359",
    stroke: "#546E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.648 197.464L185.247 190.461",
    stroke: "#546E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.797 197.464L233.384 157.356",
    stroke: "#546E6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.901 197.464L239.113 167.774",
    stroke: "#546E6B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M225.571 197.464L238.593 184.442",
    stroke: "#546E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard9);
export default __webpack_public_path__ + "static/media/Card9.b01d59c7197407ec9aaed20c8ef86cae.svg";
export { ForwardRef as ReactComponent };